export default "__VITE_ASSET__C8Pr6Nnf__"